import { render, staticRenderFns } from "./ListDealDocumentTypes.vue?vue&type=template&id=309ccfa4"
import script from "./ListDealDocumentTypes.vue?vue&type=script&lang=js"
export * from "./ListDealDocumentTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports